import { Layout, Header } from '@kanda-libs/ks-design-library';

import { Content } from '../components';

interface ViewComponentProps {
  /**
   * Disabled state
   */
  disabled?: boolean;
  /**
   * Function to sign in with Google
   */
  signInWithGoogle?: () => unknown;
}

const ViewComponent = ({ ...props }: ViewComponentProps) => (
  <Layout noBorder header={<Header.Base lines />}>
    <div className="flex flex-col flex-1 -mt-10 justify-center">
      <Content {...props} />
    </div>
  </Layout>
);

ViewComponent.displayName = 'StaffLogin-Mobile-view';

ViewComponent.defaultProps = {
  disabled: false,
  signInWithGoogle: undefined,
};

export default ViewComponent;
